import MCommunityRuleCard from './MCommunityRuleCard.vue';

export { MCommunityRuleCard };
export default MCommunityRuleCard;
